<template>
    <div class="lang arabic">
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">الخدمات المقدمة في الأجنحة والاحتياطات التي يجب الانتباه لها</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">المستلزمات المطلوب إحضارها</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">مواعيد جولات الأطباء</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">الوجبات</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">تعليمات الزيارة والاحتياطات التي يجب الانتباه لها</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">معلومات أخرى</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">الخدمات المقدمة في الأجنحة والاحتياطات التي يجب الانتباه لها</h3>
            <h4 class="bullet02 type2 num1 depth">طريقة استدعاء المساعدة في حالة الطوارئ</h4>
            <p class="depth">
                في حالة الطوارئ أو عندما تحتاج إلى مساعدة من الممرضة، يمكنك الحصول على مساعدة فورية عن طريق الضغط على جرس الطوارئ الموجود بجانب السرير أو على جدار الحمام أو غرفة الاستحمام.
            </p>

            <h4 class="bullet02 type2 num2 depth">ارتداء سوار تعريف المريض</h4>
            <p class="depth">
                للتأكد من هوية المريض بدقة، يجب ارتداء سوار تعريف المريض، حيث يتم من خلاله التحقق من اسم المريض ورقم التسجيل. في حال اتساخ السوار أو تعرضه للتلف، يرجى إبلاغ مكتب التمريض ليتم استبداله على الفور.
            </p>

            <h4 class="bullet02 type2 num3 depth">حماية الأطفال المرضى من الاختفاء والاختطاف</h4>
            <p class="depth">لحماية الأطفال المرضى من الاختفاء والاختطاف، يُطلب من أولياء الأمور التواجد مع الأطفال المرضى في جميع الأوقات.</p>

            <h4 class="bullet02 type2 num4 depth">في حال ملاحظة أي علامات غير طبيعية على المريض (تغير في الوعي، ألم في الصدر، نزيف، تشنجات)، يُرجى إبلاغ الطاقم الطبي أو طاقم المستشفى على الفور.</h4>

            <h4 class="bullet02 type2 num5 depth">الانتقال إلى غرف المستشفى</h4>
            <p class="depth">داخل غرف المستشفى من نفس المستوى، يُمنع الانتقال إلى سرير آخر بناءً على التفضيلات الشخصية لأسباب تتعلق بسلامة المريض (مثل: الأدوية، سحب الدم، توزيع الطعام، العلاجات)، وما إلى ذلك.</p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">المستلزمات المطلوب إحضارها</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">الأغراض الشخصية</h4>
                    <p class="bullet03 depth font-main">بطاقة هوية المريض (إلزامي)</p>
                    <p class="bullet05 depth">للتحقق من الهوية - يمكن استخدام الهوية الرقمية أو بطاقة التأمين الصحي</p>
                    <p class="bullet05 depth">في حالة كون المريض قاصرًا - يمكن استبدال شهادة العلاقة العائلية أو نسخة من سجل الأسرة</p>
                    <p class="bullet05 depth font-sub">قانون التأمين الصحي الوطني "نظام التحقق من هوية المريض" (ساري اعتبارًا من 20 مايو 2024)</p>
                    <p class="bullet03 depth">الأدوية: يرجى تقديم وصفة الأدوية أو كيس الأدوية الذي يحتوي على اسم الدواء إلى محطة الممرضة في الجناح</p>
                    <p class="bullet03 depth">الأغراض الشخصية: مستلزمات النظافة، المناشف، أحذية داخلية مغلقة للمريض (النعال أو الكروكس ممنوعة)، ورق تواليت، كوب ماء، بطانيات للوصي وغيرها من الأغراض الشخصية</p>
                    <h4 class="bullet02 type2 num2 depth">ملاحظات إضافية</h4>
                    <p class="bullet03 depth">إذا كانت هناك عملية جراحية مجدولة، يرجى إزالة العناية بالأظافر</p>
                    <p class="bullet03 depth">الأغراض الشخصية: مستلزمات النظافة، المناشف، أحذية داخلية مغلقة للمريض (النعال أو الكروكس ممنوعة)، ورق تواليت، ومنع استخدام الأجهزة الكهربائية مثل أجهزة الترطيب، والغلايات الكهربائية، والبطانيات الكهربائية، والمراوح، وغيرها من المواد القابلة للاشتعال والحرارة لتجنب الحوادث والإصابات، بطانيات للوصي وغيرها من الأغراض الشخصية</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">مواعيد جولات الأطباء</h3>
            <p class="depth">تقام الجولات بين الساعة 8:00 صباحًا و10:00 صباحًا، و5:00 مساءً و6:00 مساءً، وقد تختلف حسب ظروف القسم الطبي.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">الوجبات</h3>
            <p class="bullet04 num1 depth">
                يتم تقديم وجبة الإفطار من الساعة 7:00 إلى الساعة 8:00 صباحًا، والغداء من الساعة 12:00 إلى الساعة 1:00 ظهرًا، والعشاء من الساعة 6:00 إلى الساعة 7:00 مساءً. يُرجى الامتناع عن إدخال الطعام من الخارج أو تناوله في قاعة الطعام من أجل علاج المرضى والوقاية من العدوى.
            </p>
            <p class="bullet04 num2 depth">
                تخزين الطعام في الثلاجة: قد تتلف الأطعمة المطهية، باستثناء الأطعمة المخمرة، إذا طالت فترة التخزين، لذا يرجى تخزينها لمدة أقصاها 24 ساعة فقط.
            </p>
            <p class="bullet04 num3 depth">إذا رغب المريض، يمكنه اختيار "وجبة خاصة" غير مشمولة بالتأمين، وفي هذه الحالة سيتحمل المريض تكلفة الوجبة بالكامل.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">تعليمات الزيارة والاحتياطات التي يجب الانتباه لها</h3>
            <p class="bullet04 num1 depth">
                لضمان التعافي السريع واستقرار حالة المريض والوقاية من العدوى، يُمنع الأطفال دون سن 13 عامًا والذين يعانون من ضعف المناعة من زيارة غرف العزل الخاصة بالأمراض المعدية ووحدات العناية المركزة.
            </p>
            <p class="bullet04 num2 depth">
                يُمنع الزوار المصابون بنزلات البرد أو الأمراض المعدية من الزيارة. إذا كان المريض يرغب في حماية خصوصيته أو لا يرغب في الزيارة، يرجى إبلاغ مكتب التمريض.
            </p>
            <p class="bullet04 num3 depth">يرجى التعاون والتسجيل في قائمة الزوار حتى يتسنى لنا تنظيم الزيارات بشكل مناسب.</p>
            <p class="bullet04 num4 depth"><span class="font-main">أوقات الزيارة المسموح بها</span></p>
            <p class="bullet05 depth">يسمح فقط لشخص واحد يحمل تصريح إقامة.</p>
            <p class="bullet05 depth">زيارة المستشفى ضرورية لسلامة المرضى والوقاية من العدوى.</p>
            <p class="bullet05 depth">يرجى استخدام الطابق الأول و الطابق الرابع من حديقة هيلسينج.</p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">معلومات أخرى</h3>
            <h4 class="bullet02 type2 num1 depth">وسائل الراحة</h4>
            <p class="depth">الأجنحة: تتوفر حمامات عامة، غرفة التنظيف ومعالجة الفضلات، غرفة الاستحمام، استراحة، ماكينة بيع، جهاز تنقية المياه، ميكروويف، غرفة متعددة الأغراض، إلخ.</p>
            <p class="depth">تتوفر ماكينات دفع الرسوم الطبية آليًا، وماكينات تسجيل أقراص الفيديو المدمجة، ومتاجر، وبنوك، مقاهي، وقاعة الطعام، ومخابز، وأجهزة طبية، وصناديق الطرود الآلية.</p>

            <h4 class="bullet02 type2 num2 depth">فرز النفايات</h4>
            <p class="depth">يرجى التخلص من الكحول الطبي والشاش المستخدمين في حاوية النفايات الطبية المخصصة.</p>

            <h4 class="bullet02 type2 num3 depth">الامتناع عن التدخين</h4>
            <p class="depth">من أجل صحة المرضى والوقاية من الحرائق، يُحظر التدخين في جميع مرافق المستشفى، لذا يرجى منكم التعاون والامتناع عن التدخين.</p>

            <h4 class="bullet02 type2 num4 depth">طرق الوقاية من الحرائق والتعامل معها</h4>
            <p class="depth">
                يرجى الامتناع عن استخدام مواقد الغاز المحمولة، والمراوح، والسخانات الكهربائية، أو إدخال المواد القابلة للاشتعال إلى غرف انتظار عائلات المرضى. في حالة حدوث حريق، يرجى إبلاغ طاقم المستشفى فورًا واتباع تعليمات الطاقم للإخلاء عبر غرفة الإخلاء وسلالم الطوارئ.
            </p>

            <h4 class="bullet02 type2 num5 depth">تعليمات المشي</h4>
            <p class="depth">
                يُمنع الخروج للتمشية خارج المبنى كقاعدة عامة. ومع ذلك، يُسمح بالتمشية في حديقة الطابق الرابع من المبنى والساحة العشبية الموجودة عند البوابة الشمالية بعد الحصول على تصريح من الممرضة المسؤولة وبرفقة المرافق. يجب أن تأخذ هاتفك الخلوي معك خلال التمشية وأن تعود إلى الغرفة بحلول الساعة 6 مساءً.
            </p>

            <h4 class="bullet02 type2 num6 depth">التعامل مع الشكاوى والتظلمات</h4>
            <p class="depth">
                إذا كانت لديك أية استفسارات أو شعرت بالانزعاج أثناء استخدام مرافق المستشفى، أو لديك أي شيء ترغب في الإشادة به، يمكنك ذلك من خلال زيارة غرفة رضا العملاء في الطابق الأول، أو الاتصال عبر الهاتف، أو زيارة الموقع الإلكتروني للمستشفى.
            </p>

            <h4 class="bullet02 type2 num7 depth">رسوم مواقف السيارات</h4>
            <p class="depth">يرجى الرجوع إلى تعليمات رسوم مواقف السيارات المنشورة على لوحة الإعلانات الموجودة عند الأجنحة.</p>

            <h4 class="bullet02 type2 num8 depth">تنبيه بشأن فقدان أو سرقة المتعلقات الشخصية</h4>
            <p class="depth">
                <span class="font-main">
                    لا تحتفظ بالأشياء الثمينة والنقود في غرفة المستشفى
                </span>
                ، كما أنه يجب إزالة الأدوات المساعدة مثل أطقم الأسنان، والمعينات السمعية، والنظارات الطبية، والعدسات، وغيرها أثناء الفحوصات والإجراءات الطبية والعمليات الجراحية وحالات الطوارئ، لذا يرجى 
                <span class="font-main">الاحتفاظ بها بشكل آمن. المستشفى غير مسؤول عن أي حادث فقدان ناتج عن الإهمال الشخصي.</span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">الاحتفاظ بالمتعلقات الشخصية</span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>يرجى الحذر عند إزالة أي مما يلي من أجل الخضوع للفحص أو العلاج لضمان عدم فقدانها. </p>
                <p>يرجى الإحاطة بأن المستشفى غير مسؤول عن أي حادث فقدان ناتج عن الإهمال الشخصي.</p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">دليل المرافق الدينية</h4>
            <p class="depth">
                يعد هذا المستشفى مستشفى مسيحيًا، ويُقام قداس يوم الأحد في الساعة 10 صباحًا، وقداس الأربعاء في الساعة 5 مساءً، وخدمة الأطفال والشباب يوم الخميس في الساعة 10 صباحًا، وذلك في كنيسة "بانغجو" بالطابق الثالث من المبنى C. للاستفسارات حول الزيارات الرعوية، والاستشارات الدينية، أو المشورة الروحية، يمكن الاتصال بغرفة الاستشارات الرعوية على الرقم (02-6986-5724). توجد غرفة الاستشارات الرعوية والقاعة المخصصة للصلاة أيضًا في الطابق الثالث من المبنى C.
            </p>

            <h4 class="bullet02 type2 num10 depth">إصدار الوثائق والشهادات: </h4>
            <p class="depth">
                يرجى إبلاغ الطبيب المسؤول أو الممرضة مسبقًا بالوثائق المطلوبة، مثل التقارير الطبية، نسخ السجلات الطبية أو الأشعة.
            </p>

            <h4 class="bullet02 type2 num11 depth">نحن نحترم ونحمي حقوق وواجبات المرضى في جميع مراحل العلاج.</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>حقوق المرضى</th>
                                <th>واجبات المرضى</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">الحق في تلقي الرعاية الطبية</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">الالتزام بالثقة واحترام العاملين في المجال الطبي</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">الحق في المعرفة وحق اتخاذ القرارات الشخصية </p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">الحق في حماية السرية</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">الالتزام بعدم تلقي العلاج الطبي بوسائل غير قانونية</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">الحق في طلب الاستشارة والتسوية</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">الحق في الحصول على الخدمات الطبية في بيئة طبية آمنة</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">رفض تقديم الخدمات الطبية</h4>
            <p class="depth">
                إذا قام المريض أو المرافق أو أي شخص بارتكاب أعمال قد تشكل إهانة أو تشهيرًا أو اعتداء أو عرقلة لسير العمل ضد أفراد الطاقم الطبي، وبالتالي منعهم من تقديم الخدمات الطبية بشكل طبيعي، يجوز لأفراد الطاقم الطبي رفض تقديم الخدمات الطبية (الحق في رفض تقديم الخدمات الطبية) في النطاق الذي لا يُنتهك فيه قانون الخدمات الطبية وقانون خدمات الطوارئ الطبية.
            </p>
            <h4 class="bullet02 type2 num13 depth">
                إذا تعرض أي موظف للاعتداء من المريض أو المرافق له (الزائر) (مثل العنف اللفظي، التهديدات، الشغب، الاعتداء الجنسي، التحرش الجنسي، أو تخريب الممتلكات)، فقد تتم معاقبته وفقًا للقوانين ذات الصلة المعمول بها.
            </h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>